<template>
    <!-- <applets> -->
          <div class="appletscode_mask" v-show="isShow">
            <div class="appletsinner">
              <div class="title">
                <p>发布帖子</p>
                <span class="close" @click="applets_close"><img src="../../assets/imgs/c2.png"></span>
              </div>
              <div class="content">
                <img src="../../assets/imgs/applets_code.jpg">
                <p>微信扫码打开邻友圈小程序，随时随地分享生活</p>
              </div>
            </div>
          </div>
    <!-- </applets> -->
</template>
<script>
export default {
    props:['isShow'],
    data() {
        return {
        }
    },
    methods:{
      applets_close(){
        this.$emit('closeFn', false);
      },
    }
}
</script>
<style lang="less" scoped>
@import '~@/assets/less/index.less';
    // applets{
        //发帖小程序码弹窗
        .appletscode_mask{
          position: fixed;
          width:100%;
          height: 100%;
          background:rgba(0,0,0,.5);
          left:0;
          right: 0;
          bottom: 0;
          top:0;
          z-index:9999;
          .appletsinner{
            width: 500px;
            height: 200px;
            margin: 0 auto;
            margin-top: 200px;
            .title{
              width: 100%;
              height: 40px;
              line-height: 40px;
              background-color: #fff;
              color: #333;
              padding: 0 10px;
              box-sizing: border-box;
              border-bottom: 1px solid #f2f2f2;
              position: relative;
              .close{
                display: block;
                position: absolute;
                right: 10px;
                top: 0;
                cursor: pointer;
                img{
                  width: 12px;
                  height: 12px;
                }
              }
            }
            .content{
              width: 100%;
              background: #fff;
              text-align: center;
              padding:30px 0 50px 0;
              img{
                display: block;
                width: 150px;
                height: 150px;
                margin: 0px auto;
              }
              p{
                margin-top: 20px;
                font-size: 14px;
              }
            }
          }

        }

    // }
</style>



// WEBPACK FOOTER //
// src/components/common/applets.vue